<template>
    <div>
        <comment-form-modal 
            ref="formModal" 
            :is-loading="isLoadingGrid" 
            @on-save="handleUpdate" 
        />

        <bita-breadcrumb :items="breadCrumbs" />

        <div class="wrapper wrapper-content animated fadeInRight">
            <bita-ibox :is-loading="isLoadingGrid">
                <div slot="body">
                    
                    <!-- فیلتر نظرات -->
                    <div class="row mb-4 bg-light p-3 rounded border">
                        <div class="col-12 mb-2"><strong>فیلتر نظرات:</strong></div>
                        
                        <bita-select
                            name="filter_doctor"
                            label="انتخاب پزشک"
                            :validation-container-class="col4"
                            :data-source="doctorsList"
                            data-text-field="name"
                            data-value-field="id"
                            v-model="filters.doctor_id"
                        />
                        
                        <div class="col-lg-4 d-flex align-items-end mb-3">
                            <bita-bootbutton type="info" title="جستجو" icon="fas fa-search" @click.native="loadData" />
                            <bita-bootbutton type="default" title="پاک کردن" class="mr-2" @click.native="clearFilters" />
                        </div>
                    </div>

                    <hr />

                    <bita-grid 
                        ref="grid" 
                        :columns="gridColumns" 
                        :read-data="readData" 
                        :page-size="pageSize"
                        :current-page="currentPage" 
                        :has-row-number="true" 
                        :grid-server-side="true"
                        :schema-total="'total'" 
                        :schema-data="'data'" 
                        :server-paging="true"
                    />
                </div>
            </bita-ibox>
        </div>
    </div>
</template>

<script>
import doctorsCommentsApi from '../../../api/clinic/doctorsCommentsApi';
import doctorsApi from '../../../api/clinic/doctorsApi'; // فرض بر وجود این فایل برای لیست پزشکان
import CommentFormModal from './components/CommentFormModal';

export default {
    components: { CommentFormModal },
    data() {
        return {
            col4: "col-lg-4",
            pageSize: 15,
            currentPage: 1,
            isLoadingGrid: false,
            breadCrumbs: [
                { title: "صفحه اصلی", link: "/" },
                { title: "مدیریت نظرات بیماران", link: "/clinic/comments", active: true },
            ],
            filters: {
                doctor_id: null,
            },
            doctorsList: []
        };
    },

    mounted() {
        this.fetchDoctors();
    },

    computed: {
        gridColumns() {
            return [
                { 
                    field: "doctor", 
                    title: "پزشک", 
                    template: ({ doctor }) => doctor ? doctor.name : " - " 
                },
                { 
                    field: "user", 
                    title: "بیمار", 
                    template: ({ user }) => user ? (user.name || user.mobile) : " - " 
                },
                { 
                    field: "comment", 
                    title: "متن نظر", 
                    template: ({ comment }) => `<div style="max-width:300px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;" title="${comment}">${comment}</div>` 
                },
                { 
                    field: "score", 
                    title: "امتیاز", 
                    template: ({ score }) => `<span class="badge badge-info">${score} ستاره</span>` 
                },
                { 
                    field: "is_like", 
                    title: "وضعیت", 
                    template: ({ is_like }) => is_like 
                        ? '<i class="fa fa-thumbs-up text-success" title="پیشنهاد شده"></i>' 
                        : '<i class="fa fa-thumbs-down text-danger" title="پیشنهاد نشده"></i>' 
                },
                { title: "عملیات", command: this.gridCommands() },
            ];
        },
    },

    methods: {
        fetchDoctors() {
            // دریافت لیست پزشکان برای دراپ‌داون فیلتر
            doctorsApi.get({ page_size: 1000 }).then(({ data }) => {
                this.doctorsList = data.data || data;
            });
        },

        clearFilters() {
            this.filters.doctor_id = null;
            this.loadData();
        },

        loadData() {
            this.$refs.grid.loadDataSource();
        },

        readData(e) {
            this.$resetGrid();
            this.pageSize = e.data.pageSize;
            this.currentPage = e.data.page;
            this.isLoadingGrid = true;

            const queryParams = {
                per_page: this.pageSize,
                page: this.currentPage,
            };

            if (this.filters.doctor_id) {
                queryParams.doctor_id = this.filters.doctor_id;
            }

            doctorsCommentsApi.get(queryParams)
                .then(({ data }) => {
                    e.success(data);
                })
                .catch(() => e.success([]))
                .finally(() => { this.isLoadingGrid = false; });
        },

        edit(e) {
            const data = this.$refs.grid.getSelectedGridRow(e);
            this.$refs.formModal.init(data);
            this.$toggleModal("#comment-form-modal");
        },

        handleUpdate(formData) {
            this.isLoadingGrid = true;
            doctorsCommentsApi.update(formData.id, formData)
                .then(() => {
                    this.$izitoast("success", "عملیات موفق", "نظر با موفقیت ویرایش شد.");
                    this.$toggleModal("#comment-form-modal");
                    this.loadData();
                })
                .catch((err) => {
                    if(err.response && err.response.data && err.response.data.message) {
                        this.$izitoast("error", "خطا", err.response.data.message);
                    }
                })
                .finally(() => { this.isLoadingGrid = false; });
        },

        delete(e) {
            const data = this.$refs.grid.getSelectedGridRow(e);

            this.$alert("question", `آیا از حذف نظر بیمار (${data.user?.name || 'ناشناس'}) اطمینان دارید؟`, "", {
                confirmButtonText: "بله، حذف شود",
            }).then((result) => {
                if (result.value) {
                    this.isLoadingGrid = true;
                    doctorsCommentsApi.delete(data.id)
                        .then(() => {
                            this.$izitoast("success", "عملیات موفق", "نظر حذف شد.");
                            this.loadData();
                        })
                        .finally(() => { this.isLoadingGrid = false; });
                }
            });
        },

        gridCommands() {
            return [
                { text: "edit", template: this.gridButtons.edit, click: this.edit },
                { text: "delete", template: this.gridButtons.delete, click: this.delete },
            ];
        },
    },
};
</script>
